
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import JourneyHeader from "@/components/JourneyHeader";

const ContactOwner = () => {
  const navigate = useNavigate();

  const handleExitToHome = () => {
    navigate('/home');
  };

  return (
    <div className="min-h-screen bg-intellend-white">
      {/* Header with logo */}
      <JourneyHeader />

      {/* Main content */}
      <main className="container mx-auto px-4 py-8 max-w-3xl">
        <div className="bg-white shadow-md rounded-lg p-6 mb-6 text-center">
          <h2 className="text-2xl font-bold text-intellend-green mb-6">Additional Information Required</h2>
          
          <div className="my-8">
            <p className="text-lg text-gray-700">
              Please contact one of your business owner, partner or director to apply for the loan.
            </p>
          </div>
          
          <div className="mt-8">
            <Button 
              onClick={handleExitToHome}
              className="bg-intellend-green hover:bg-intellend-green/90 w-full md:w-auto"
            >
              Exit to Home
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ContactOwner;
